function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailboxBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378,152.56c-15.56-8.52-31.77-11.94-49.46-9.75-21.79,2.69-39,5.86-59.85-2.26-17.53-6.82-33.54-17-50.26-25.44-34.2-17.35-68.15-22.72-93.79,11.5-13.64,18.21-24,39.12-31.15,61.18-11.56,35.59-21.06,75-15.85,112.17,6.59,47.12,47,69.24,95.34,52.17,19.55-6.9,38.42-17,59.27-19.89,43.63-6.06,79.59,34,131.91,24.26C454.34,339.74,447.68,190.71,378,152.56Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,152.56c-15.56-8.52-31.77-11.94-49.46-9.75-21.79,2.69-39,5.86-59.85-2.26-17.53-6.82-33.54-17-50.26-25.44-34.2-17.35-68.15-22.72-93.79,11.5-13.64,18.21-24,39.12-31.15,61.18-11.56,35.59-21.06,75-15.85,112.17,6.59,47.12,47,69.24,95.34,52.17,19.55-6.9,38.42-17,59.27-19.89,43.63-6.06,79.59,34,131.91,24.26C454.34,339.74,447.68,190.71,378,152.56Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-1--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.65,114.17c-6.35-3.47-9.23-.58-11.54-3.47s6.35-10.39-11-17.89c0,0-1.15-16.16-24.82-16.74S327,92.23,320.65,96.27,312.57,94,306.22,98s-3.46,12.12-8.65,13.27-12.13-5.19-18.48-1.15-6.35,7.5-9.23,7.5-8.66-2.31-12.12,0-7.51,5.2-7.51,5.2h146S398,117.63,391.65,114.17Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.65,114.17c-6.35-3.47-9.23-.58-11.54-3.47s6.35-10.39-11-17.89c0,0-1.15-16.16-24.82-16.74S327,92.23,320.65,96.27,312.57,94,306.22,98s-3.46,12.12-8.65,13.27-12.13-5.19-18.48-1.15-6.35,7.5-9.23,7.5-8.66-2.31-12.12,0-7.51,5.2-7.51,5.2h146S398,117.63,391.65,114.17Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.08,243.9c-4.46-2.43-6.49-.41-8.11-2.43s4.46-7.3-7.7-12.57c0,0-.81-11.35-17.44-11.76s-12.16,11.35-16.62,14.19-5.67-1.62-10.13,1.22-2.44,8.51-6.08,9.32-8.52-3.65-13-.81-4.46,5.27-6.48,5.27-6.09-1.62-8.52,0-5.27,3.65-5.27,3.65H229.32S230.54,246.33,226.08,243.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.08,243.9c-4.46-2.43-6.49-.41-8.11-2.43s4.46-7.3-7.7-12.57c0,0-.81-11.35-17.44-11.76s-12.16,11.35-16.62,14.19-5.67-1.62-10.13,1.22-2.44,8.51-6.08,9.32-8.52-3.65-13-.81-4.46,5.27-6.48,5.27-6.09-1.62-8.52,0-5.27,3.65-5.27,3.65H229.32S230.54,246.33,226.08,243.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.87,412.87h63.2c-1.21-7.73-6.18-6.37-6.84-18.35-.33-6,5.26-13.5,4.77-21.42-.4-6.53-6.83-13.22-7.33-20.69-.45-6.74,5-14.22,4.51-21.48-.51-6.86-7-13.45-7.61-20.59-.56-7,4.82-14.51,4.18-21.55s-7.27-13.51-8-20.45c-.73-7.13,4.48-14.81,3.68-21.63-.84-7.25-7.68-13.51-8.61-20.19-1-7.43,3.81-15.37,2.68-21.79-1.39-7.86-8.71-13.55-10.25-19.35-2.87-10.81-2.51-21.22-5.9-21.9-3.61-.72-4.44,9.49-7.18,20.9-1.38,5.73-8.53,11.54-9.71,19.41-.95,6.37,4.11,14.12,3.28,21.52-.74,6.63-7.41,13-8.06,20.21-.61,6.78,4.8,14.25,4.27,21.34-.52,6.89-7,13.46-7.43,20.46s5.13,14.32,4.75,21.23c-.39,7.08-6.74,13.77-7.07,20.58-.34,7.21,5.35,14.48,5.07,21.16-.31,7.41-6.57,14.19-6.8,20.67-.28,7.86,5.49,15.11,5.31,21.1-.38,13-6.33,10.29-6.54,20.75Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 184.25,
    x2: 380,
    y2: 409.95,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "389.87 207.91 379.58 216.8 371.16 205.57",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "389.87 247.2 379.58 256.08 371.16 244.86",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "389.87 284.14 379.58 293.03 371.16 281.8",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "389.87 328.11 379.58 336.99 371.16 325.77",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "389.87 372.54 379.58 381.42 371.16 370.2",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.82,412.87h48.79c-.94-6-4.77-4.92-5.28-14.16-.26-4.66,4.05-10.42,3.68-16.54-.31-5-5.27-10.21-5.66-16-.35-5.2,3.89-11,3.48-16.58-.39-5.3-5.42-10.38-5.87-15.89s3.72-11.21,3.23-16.64-5.62-10.43-6.16-15.78c-.56-5.51,3.46-11.43,2.84-16.71-.65-5.59-5.93-10.42-6.64-15.57-.8-5.74,2.94-11.87,2.06-16.82-1.07-6.07-6.72-10.47-7.9-14.94-2.22-8.34-1.94-16.39-4.56-16.91-2.79-.56-3.43,7.32-5.54,16.14-1.06,4.42-6.59,8.91-7.5,15-.73,4.92,3.17,10.9,2.53,16.61-.57,5.12-5.71,10-6.22,15.6-.47,5.23,3.71,11,3.3,16.47-.4,5.32-5.39,10.39-5.74,15.79s4,11.06,3.67,16.39-5.2,10.63-5.45,15.89c-.27,5.56,4.12,11.17,3.91,16.33-.24,5.72-5.07,11-5.25,16-.22,6.06,4.24,11.67,4.1,16.28-.3,10-4.89,7.95-5.05,16Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.77,
    y1: 236.4,
    x2: 330.77,
    y2: 410.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "338.38 254.66 330.44 261.52 323.94 252.85",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "338.38 284.98 330.44 291.84 323.94 283.18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "338.38 313.5 330.44 320.36 323.94 311.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "338.38 347.44 330.44 354.3 323.94 345.63",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "338.38 381.74 330.44 388.59 323.94 379.93",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mailbox--inject-1--inject-74"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "266.33 412.4 266.33 210.22 277 210.22 277 412.4",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "261 412.4 261 210.22 271.67 210.22 271.67 412.4",
    style: {
      fill: "#219297",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 210.22,
    width: 10.67,
    height: 24,
    style: {
      fill: "#2e353a",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.53,131.29H227.47l34.46,84.64H341V165.75A34.46,34.46,0,0,0,306.53,131.29Z",
    style: {
      fill: "#219297",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.9,201.11l6,14.82H341V165.75c0-.76,0-1.52-.08-2.27h-85Z",
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.95,
    y1: 163.48,
    x2: 297.63,
    y2: 163.48,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.92,
    y1: 163.48,
    x2: 315.74,
    y2: 163.48,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.47,131.29h0a34.47,34.47,0,0,1,34.47,34.47v50.18a0,0,0,0,1,0,0H193a0,0,0,0,1,0,0V165.75A34.47,34.47,0,0,1,227.47,131.29Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.53,
    y: 210.22,
    width: 59.4,
    height: 5.71,
    style: {
      fill: "#219297",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 210.22,
    width: 122.93,
    height: 5.71,
    style: {
      fill: "#219297",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.53,
    y: 210.22,
    width: 59.4,
    height: 5.71,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 110.89,
    width: 24.67,
    height: 17.33,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.67,
    y: 110.89,
    width: 5.33,
    height: 54,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.33,
    cy: 166.22,
    r: 6,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-planes--inject-1--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.34,145.15c13.92,7.07,38.12,18.4,60.44,24.1",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2,4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66,139s4.46,2.52,11.68,6.19",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2,4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.65 138.63 191.66 114.85 119.07 97.14 181.65 138.63",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2629000000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.53 117.73 181.65 138.63 119.07 97.14 186.53 117.73",
    style: {
      fill: "#219297",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2629000000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.53 117.73 175.14 127.49 119.07 97.14 186.53 117.73",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2629000000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.66 114.85 201.8 110.73 119.07 97.14 191.66 114.85",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2629000000000001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.55,
    y1: 134.93,
    x2: 169.9,
    y2: 136.37,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.73,
    y1: 127.07,
    x2: 162.6,
    y2: 131.89,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.89 184.15 145.89 158.36 219.67 170.22 145.89 184.15",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2629000000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.5 163 145.89 184.15 219.67 170.22 149.5 163",
    style: {
      fill: "#219297",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2629000000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.5 163 156.21 176.41 219.67 170.22 149.5 163",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2629000000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.89 158.36 138.15 150.62 219.67 170.22 145.89 158.36",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2629000000000001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.31,
    y1: 183.67,
    x2: 178.71,
    y2: 182.37,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.83,
    y1: 188.24,
    x2: 165.92,
    y2: 184.97,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,182.56s-58,10-69,62,47,55,57,30-34-35-44-11,20,65,61,67c34.07,1.66,129.59-38.11,189-48.16,0,0,44-12.18,112-9.51",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2,4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-1--inject-74"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 423.33,
    y1: 345.56,
    x2: 440,
    y2: 345.56,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.33,
    y1: 370.22,
    x2: 440,
    y2: 370.22,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "72.33 369.56 421.33 369.56 421.33 346.22 72.33 346.22",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.59,412.56V295.14a2.13,2.13,0,0,1,.66-1.54l9.12-8.59a2.13,2.13,0,0,1,3,.09l8,8.51a2.17,2.17,0,0,1,.57,1.45v117.5",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,413.56V295.14a2.1,2.1,0,0,1,.67-1.54l9.12-8.59a2.12,2.12,0,0,1,3,.09l8,8.51a2.12,2.12,0,0,1,.57,1.45v118.5",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.49,412.56V295.14a2.13,2.13,0,0,1,.66-1.54l9.13-8.59a2.12,2.12,0,0,1,3,.09l8,8.51a2.12,2.12,0,0,1,.57,1.45v117.5",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.33,413.56V295.14a2.1,2.1,0,0,1,.67-1.54l9.12-8.59a2.13,2.13,0,0,1,3,.09l8,8.51a2.13,2.13,0,0,1,.58,1.45v118.5",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.82,412.56V295.14a2.1,2.1,0,0,1,.67-1.54l9.12-8.59a2.13,2.13,0,0,1,3,.09l8,8.51a2.13,2.13,0,0,1,.58,1.45v118.5",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67,413.56V295.14a2.13,2.13,0,0,1,.66-1.54l9.13-8.59a2.12,2.12,0,0,1,3,.09l8,8.51a2.12,2.12,0,0,1,.57,1.45v118.5",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.16,412.56V295.14a2.13,2.13,0,0,1,.66-1.54l9.12-8.59a2.13,2.13,0,0,1,3,.09l8,8.51a2.17,2.17,0,0,1,.57,1.45v117.5",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,413.56V295.14a2.1,2.1,0,0,1,.67-1.54l9.12-8.59a2.12,2.12,0,0,1,3,.09l8,8.51a2.12,2.12,0,0,1,.57,1.45v118.5",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.49,412.56V295.14a2.13,2.13,0,0,1,.66-1.54l9.13-8.59a2.12,2.12,0,0,1,3,.09l8,8.51a2.12,2.12,0,0,1,.57,1.45v117.5",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.33,413.56V295.14a2.1,2.1,0,0,1,.67-1.54l9.12-8.59a2.13,2.13,0,0,1,3,.09l8,8.51a2.13,2.13,0,0,1,.58,1.45v118.5",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.78,
    y1: 285.1,
    x2: 106.78,
    y2: 293.66,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.21,
    y1: 289.52,
    x2: 110.21,
    y2: 309.78,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.54,
    y1: 291.18,
    x2: 175.54,
    y2: 316.81,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.85,
    y1: 287.87,
    x2: 178.85,
    y2: 299.03,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.46,
    y1: 285.01,
    x2: 258.46,
    y2: 310.2,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.21,
    y1: 287.04,
    x2: 263.21,
    y2: 324.26,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.78,
    y1: 291.18,
    x2: 329.78,
    y2: 319.29,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.53,
    y1: 287.87,
    x2: 340.53,
    y2: 294.9,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.41,
    y1: 287.45,
    x2: 410.41,
    y2: 302.34,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.51,
    y1: 289.11,
    x2: 419.51,
    y2: 332.11,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.97,
    y1: 351.96,
    x2: 393.87,
    y2: 351.96,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.97,
    y1: 358.99,
    x2: 371.13,
    y2: 358.99,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.29,
    y1: 358.99,
    x2: 269.82,
    y2: 358.99,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.21,
    y1: 358.99,
    x2: 193.74,
    y2: 358.99,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.67,
    y1: 355.27,
    x2: 79.2,
    y2: 355.27,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.67,
    y1: 361.88,
    x2: 87.88,
    y2: 361.88,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.85,
    y1: 355.27,
    x2: 269.82,
    y2: 355.27,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.94,
    y1: 363.12,
    x2: 192.91,
    y2: 363.12,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.58,
    y1: 363.12,
    x2: 163.55,
    y2: 363.12,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.08,
    y1: 358.99,
    x2: 424.88,
    y2: 358.99,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.35,
    y1: 358.99,
    x2: 435.63,
    y2: 358.99,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,316s-2.5,21.49-5.5,43.48,2.5,44.49,4,46.49",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11,359.5c.48-4.29.88-7,.88-7",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,403.47s-9-2-9-18c0-6.57.42-13.3.92-19",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,290.5s2,1.5-1.5,18.5-3,42,1.5,56",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,322s-5,15-1.5,36",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,331.49s2.5,14.5,5,29.49.5,36-1.5,41.49-4,10-4,10",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.42,405.12c-2.23,6.84-5-1.15-5-1.15",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.33,354s4.71,24.31,2.05,42.61",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,362s5,10.5.5,20.5",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.3,363.48a68.23,68.23,0,0,0,2.63,9",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.43,311.5a138.77,138.77,0,0,0-6,31,71.49,71.49,0,0,0,.89,15.93",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.93,357.48s4.5,17,7,23,1.5,20.49-1.5,27.49",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.41,319s10,18,.5,47.49",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.6,349.74c.06,5.62-.44,12.74-2.69,18.74-4.5,12-6.5,16-6.5,16",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.91,340s.33,2.15.53,5.46",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailboxBro);
export default __webpack_public_path__ + "static/media/Mailbox-bro.ff5505f0915ac37b6c118db259340856.svg";
export { ForwardRef as ReactComponent };